import { moduleProviderFactory } from 'core/providers';
import { NikoCorporateList } from 'application/niko-corporate/pages';

(function () {
    moduleProviderFactory.application.register({
        routes: [
            {
                name: 'master.app.main.niko-corporate',
                pattern: '/niko-corporates',
                children: [
                    {
                        name: 'master.app.main.niko-corporate.list',
                        pattern: '',
                        tabTitle: 'MENU.NIKO_CORPORATES',
                        component: NikoCorporateList,
                        authorization: 'administrationSection.read',
                        data: {
                            title: 'MENU.NIKO_CORPORATES'
                        }
                    }
                ]
            }
        ],
        menu: [
            {
                title: 'MENU.FACILITIES',
                order: 4,
                icon: 'facilities',
                authorization: 'administrationSection.read',
                subMenu: [
                    {
                        title: 'MENU.NIKO_CORPORATES',
                        route: 'master.app.main.niko-corporate.list',
                        order: 3.5,
                        authorization: 'administrationSection.read',
                    }
                ]
            }
        ]
    });
})();
